import { Component, EventEmitter, input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-chip',
  standalone: true,
  templateUrl: './btn-chip.component.html',
  styleUrls: ['./btn-chip.component.css'],
})
export class BtnChipComponent {
  label = input.required<string>();
  readOnly = input<boolean>(true);
  bgColor = input<string>();
  iconColor = input<string>();
  color = input<string>();
  selectedBgColor = input<string>();
  selectedColor = input<string>();
  // icon = input<string | undefined>();
  selected = input<boolean>(false);

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  onClick(): void {
    this.clicked.emit();
  }
}
